(() => {
  'use strict';
  if (window.FabrikoneStudioGuides) return;
  let activeHandle = '', mountRevision = 0;
  const mounted = new WeakSet(), assetRequests = new Map();
  const escape = value => String(value ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  const source = () => document.querySelector('[data-studio-guides-source]');
  const guides = () => [...(source()?.querySelectorAll('template[data-studio-guide-panel]') || [])].map(template => ({handle:template.dataset.guideHandle,title:template.dataset.guideTitle,url:template.dataset.guideUrl,template}));
  const copy = () => String(document.documentElement.lang || 'tr').toLowerCase().startsWith('en')
    ? {title:'Guides',choose:'Choose a guide',loading:'Loading the guide tools…',error:'The guide tools could not load. The original guide remains available below.',retry:'Try again',empty:'The guides are currently unavailable.'}
    : {title:'Rehberler',choose:'Rehber seç',loading:'Rehber araçları yükleniyor…',error:'Rehber araçları yüklenemedi. Asıl rehber içeriği aşağıda kullanılabilir.',retry:'Tekrar dene',empty:'Rehberler şu anda kullanılamıyor.'};
  function requestedGuide() {
    const handle = new URL(location.href).searchParams.get('guide');
    return guides().some(guide => guide.handle === handle) ? handle : '';
  }
  function current(handle) {
    const items = guides();
    return items.find(guide => guide.handle === handle) || items.find(guide => guide.handle === requestedGuide()) || items.find(guide => guide.handle === activeHandle) || items[0] || null;
  }
  function render(handle) {
    const selected = current(handle), labels = copy();
    if (!selected) return '<section class="studio-guide-browser"><h2>'+escape(labels.title)+'</h2><p role="status">'+escape(labels.empty)+'</p></section>';
    activeHandle = selected.handle;
    return '<section class="studio-guide-browser" data-studio-guide-browser><h2 class="studio-guide-browser__title">'+escape(labels.title)+'</h2><nav class="studio-guide-tabs" role="tablist" aria-label="'+escape(labels.choose)+'">'+guides().map(guide => '<button type="button" role="tab" data-studio-guide-tab="'+escape(guide.handle)+'" id="StudioGuideTab-'+escape(guide.handle)+'" aria-controls="StudioGuidePanel" aria-selected="'+(guide.handle === activeHandle)+'" tabindex="'+(guide.handle === activeHandle?'0':'-1')+'">'+escape(guide.title)+'</button>').join('')+'</nav><p class="studio-guide-status" data-studio-guide-status role="status" aria-live="polite" hidden></p><button type="button" class="studio-guide-retry" data-studio-guide-retry hidden>'+escape(labels.retry)+'</button><div class="studio-guide-panel" id="StudioGuidePanel" data-studio-guide-content role="tabpanel" aria-labelledby="StudioGuideTab-'+escape(activeHandle)+'"></div></section>';
  }
  function updateURL(handle, hash, incoming) {
    const url = new URL(location.href);
    if (incoming) for (const [key,value] of incoming.searchParams) if (key !== 'view' && key !== 'guide') url.searchParams.set(key,value);
    url.searchParams.set('guide',handle);
    if (hash != null) url.hash = hash;
    history.replaceState(history.state,'',url.pathname+url.search+url.hash);
  }
  function targetFor(href) {
    try {
      const url = new URL(href,location.href);
      if (url.origin !== location.origin) return null;
      const chosen = url.searchParams.get('guide');
      const legacy = guides().find(guide => guide.url && new URL(guide.url,location.origin).pathname === url.pathname);
      const handle = guides().some(guide => guide.handle === chosen) ? chosen : legacy?.handle;
      return handle ? {handle,url} : null;
    } catch (_) { return null; }
  }
  function revealHash(panel, hash) {
    if (!hash) return;
    let id;
    try { id = decodeURIComponent(hash.replace(/^#/,'')); } catch (_) { return; }
    const target = [...panel.querySelectorAll('[id]')].find(element => element.id === id);
    if (!target) return;
    for (let parent = target.parentElement; parent && parent !== panel; parent = parent.parentElement) if (parent.tagName === 'DETAILS') parent.open = true;
    target.scrollIntoView({block:'start',behavior:'auto'});
  }
  function loadFragranceGuide() {
    if (typeof window.FabrikoneFragranceGuideHTML === 'string') return Promise.resolve();
    let config;
    try { config = JSON.parse(source().querySelector('[data-studio-guide-assets]').textContent); } catch (_) { return Promise.reject(new Error('Guide asset missing')); }
    const url = config.fragranceGuide;
    if (!url) return Promise.reject(new Error('Guide asset missing'));
    if (assetRequests.has(url)) return assetRequests.get(url);
    const promise = new Promise((resolve,reject) => {
      const script = document.createElement('script');
      script.src = url; script.dataset.fragranceGuideSource = ''; script.async = true;
      const timer = setTimeout(() => { script.remove(); reject(new Error('Guide asset timeout')); },15000);
      script.onload = () => { clearTimeout(timer); typeof window.FabrikoneFragranceGuideHTML === 'string' ? resolve() : reject(new Error('Guide asset incomplete')); };
      script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Guide asset unavailable')); };
      document.head.append(script);
    }).catch(error => { assetRequests.delete(url); throw error; });
    assetRequests.set(url,promise);
    return promise;
  }
  async function show(browser, handle, hash) {
    const selected = current(handle);
    if (!selected || !browser.isConnected) return;
    activeHandle = selected.handle;
    const panel = browser.querySelector('[data-studio-guide-content]'), status = browser.querySelector('[data-studio-guide-status]'), retry = browser.querySelector('[data-studio-guide-retry]');
    const revision = ++mountRevision;
    const fragment = selected.template.content.cloneNode(true);
    fragment.querySelectorAll('script:not([type="application/json"])').forEach(script => script.remove());
    fragment.querySelectorAll('fab-audit-kit').forEach(kit => {
      if (!kit.dataset.mainHandle && !kit.querySelector('[data-kit-main]')) kit.dataset.mainHandle = 'studio-guide:'+selected.handle;
    });
    const advisors = [...fragment.querySelectorAll('fab-audit-advisor')].map(advisor => {
      const placeholder = document.createElement('div');
      placeholder.dataset.studioGuideAdvisorSlot = '';
      advisor.replaceWith(placeholder);
      return {advisor,placeholder};
    });
    panel.replaceChildren(fragment);
    panel.setAttribute('aria-labelledby','StudioGuideTab-'+activeHandle);
    browser.querySelectorAll('[data-studio-guide-tab]').forEach(tab => {
      const pressed = tab.dataset.studioGuideTab === activeHandle;
      tab.setAttribute('aria-selected',String(pressed)); tab.tabIndex = pressed ? 0 : -1;
    });
    status.hidden = true; retry.hidden = true; panel.removeAttribute('aria-busy');
    const isAdvisor = advisors.length > 0;
    if (isAdvisor) {
      status.hidden = false; status.textContent = copy().loading; panel.setAttribute('aria-busy','true');
      try { await loadFragranceGuide(); }
      catch (_) {
        if (revision !== mountRevision || !browser.isConnected || activeHandle !== selected.handle) return;
        status.hidden = false; status.textContent = copy().error; retry.hidden = false;
        panel.removeAttribute('aria-busy'); revealHash(panel,hash); return;
      }
      if (revision !== mountRevision || !browser.isConnected || activeHandle !== selected.handle) return;
      advisors.forEach(({advisor,placeholder}) => placeholder.replaceWith(advisor));
      status.hidden = true; panel.removeAttribute('aria-busy');
    }
    if (revision === mountRevision && browser.isConnected) revealHash(panel,hash);
  }
  function mount(container) {
    const browser = container?.querySelector('[data-studio-guide-browser]');
    if (!browser || mounted.has(browser)) return;
    mounted.add(browser);
    browser.addEventListener('click',event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const tab = event.target.closest('[data-studio-guide-tab]');
      if (tab && browser.contains(tab)) {
        event.preventDefault(); const handle = tab.dataset.studioGuideTab;
        updateURL(handle,''); void show(browser,handle,''); return;
      }
      if (event.target.closest('[data-studio-guide-retry]')) { event.preventDefault(); void show(browser,activeHandle,location.hash); return; }
      const link = event.target.closest('a[href]');
      const target = link && targetFor(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault(); updateURL(target.handle,target.url.hash,target.url);
      if (target.handle === activeHandle) revealHash(browser.querySelector('[data-studio-guide-content]'),target.url.hash);
      else void show(browser,target.handle,target.url.hash);
    });
    browser.addEventListener('keydown',event => {
      const tab = event.target.closest('[data-studio-guide-tab]');
      if (!tab || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
      const tabs = [...browser.querySelectorAll('[data-studio-guide-tab]')], index = tabs.indexOf(tab);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
      event.preventDefault(); tabs[next].focus(); tabs[next].click();
    });
    void show(browser,activeHandle || requestedGuide(),location.hash);
  }
  window.FabrikoneStudioGuides = Object.freeze({render,mount,requestedGuide});
})();
